export default __webpack_public_path__ + "static/media/close_ranks.ce258895.png";